import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: 275,
  },
  title: {
    fontSize: 14,
  },
  mediaCard: {
    width: '100%',
    height: 'auto',
  },
  h7: {
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '16px',
    color: '#0E1247',
    textAlign: 'center',
    display: 'inline-block',
    style: 'normal',
    alignItems: 'center',
  },
  textCard: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '19.6px',
    color: '#0E1247',
    style: 'normal',
  },
  cardContainer: {
    backgroundColor: '#EDEEF2',
    padding: '16px',
    borderRadius: '10px',
    width: '100%',
    boxSizing: 'border-box',
    border: 'none',
  },
  
  // NOUVEAU LAYOUT FLEXBOX POUR IMAGES
  imageLayout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
  },
  
  // NOUVEAU LAYOUT FLEXBOX POUR TEXTE
  textLayout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
  },
  
  // CONTAINERS
  circleContainer: {
    flexShrink: 0,
  },
  
  imageContainer: {
    flexShrink: 0,
  },
  
  textInfoContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  
  textContentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  
  actionsContainer: {
    display: 'flex',
    gap: '5px',
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  
  iconButton: {
    padding: 3,
    '& img': {
      width: '16px',
      height: '16px',
    },
  },
  number: {
    color: '#fff',
    fontSize: 12,
    fontFamily: 'Poppins',
    fontWeight: 700,
    textAlign: 'center',
  },
  responseTitle: {
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 700,
    color: '#23296F',
  },
  responseVariableLabel: {
    color: '#23296F',
    fontWeight: 700,
    fontSize: '12px',
    fontFamily: 'Poppins',
    lineHeight: '16px',
    margin: 0,
  },
  responseVariableName: {
    color: '#FF6B35',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: 'Poppins',
    lineHeight: '16px',
    margin: 0,
    wordBreak: 'break-word',
    textTransform: 'uppercase',
  },
  itemContainer: {
    marginTop: '0.5rem',
  },
  responseImage: {
    width: '130px',
    height: '95px',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '9px',
    display: 'block',
  },
  
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
}));

export default useStyles;
